import { ApplicationState } from '../../store/store';

export const getCurrentLocale = (state: ApplicationState) => state.layout.currentLocale;
export const getCurrentPageTitle = (state: ApplicationState) => state.layout.currentPageTitle;